module.exports = __webpack_public_path__ + "img/menu-jianmo.462e5aba.svg";